import { conversionRouteKey } from 'constants/mapping';
import { lazyWithRetry } from 'utils/helpers';
import { types, resource } from 'constants/accessControl';
import { title } from 'constants/tabs/title';
import { RouteConfig } from 'router/types';
import { Can } from 'shared/permission';

export const brandRouters = [
  {
    id: 1,
    menuItem: true,
    name: 'brands',
    component: lazyWithRetry(() => import('features/brands/pages/Brands')),
    exact: true,
    icon: 'LeftIcon',
    path: '/brands',
    key: '/brands',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.brands}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 2,
    menuItem: true,
    name: 'mainSettings',
    component: lazyWithRetry(() => import('pages/BrandMainSettings')),
    icon: 'BrandSettingIcon',
    path: 'mainSettings',
    key: 'mainSettings',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.mainSettings}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 3,
    menuItem: true,
    name: 'sportsBook',
    component: lazyWithRetry(() => import('pages/BrandSportsBook')),
    icon: 'BrandSportIcon',
    path: 'sportsbook',
    key: 'sportsbook',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.sportsBook}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 4,
    menuItem: true,
    name: 'casinoProduct',
    component: lazyWithRetry(() => import('pages/BrandCasinoProduct')),
    icon: 'GamesAndProvidersIcon',
    path: 'casinoProduct',
    key: 'casinoProduct',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.casinoProduct}`, `${resource.brands}.${resource.casinoSettings}`, `${resource.brands}.${resource.brandJackpots}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 6,
    menuItem: true,
    name: 'payments',
    component: lazyWithRetry(() => import('pages/BrandPayments')),
    icon: 'BrandPaymentIcon',
    exact: true,
    path: 'payments',
    key: 'payments',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.failedPayments}`, `${resource.brands}.${resource.payments}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 22,
    menuItem: true,
    name: 'taxes',
    component: lazyWithRetry(() => import('pages/BrandTaxes')),
    icon: 'TaxesIcon',
    exact: true,
    path: 'taxes',
    key: 'taxes',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.taxOnDeposit}`, `${resource.brands}.${resource.taxOnWithdrawal}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 23,
    menuItem: true,
    name: 'bonusManagement',
    component: lazyWithRetry(() => import('features/bonusManagement/pages/BrandBonusManagement')),
    icon: 'BonusSettingsIcon',
    exact: true,
    path: 'bonuses',
    key: 'bonuses',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.mainSettings}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 16,
    menuItem: true,
    name: 'operatorLimits',
    component: lazyWithRetry(() => import('pages/BrandOperatorLimits')),
    icon: 'OperatorLimitsIcon',
    exact: true,
    path: 'operatorLimits',
    key: 'operatorLimits',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.largeTransactions}`, `${resource.brands}.${resource.playerLimits}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 5,
    menuItem: true,
    name: 'thirdPartyServices',
    component: lazyWithRetry(() => import('features/thirdPartyServices/pages/ThirdPartyServices')),
    icon: 'BrandThirdPartyServicesIcon',
    path: 'thirdPartyServices',
    key: 'thirdPartyServices',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.thirdPartyServices}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 7,
    menuItem: true,
    name: 'notificationSettings',
    component: lazyWithRetry(() => import('features/crm/pages/BrandNotificationSettings')),
    icon: 'BrandNotificationServiceIcon',
    exact: true,
    path: 'notificationSettings',
    key: 'notificationSettings',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.notificationSettings}`, `${resource.brands}.${resource.smtpConfigurations}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 15,
    menuItem: true,
    name: 'locationServices',
    component: lazyWithRetry(() => import('pages/BrandLocationServices')),
    icon: 'LocationServices',
    exact: true,
    path: 'locationServices',
    key: 'locationServices',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.locationServices}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 9,
    menuItem: true,
    name: 'conversionSettings',
    component: lazyWithRetry(() => import('pages/BrandConversionSettings')),
    icon: 'ConversionSettingsIcon',
    exact: true,
    path: 'conversionSettings',
    key: 'conversionSettings',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: [`${resource.brands}.${resource.conversionSettingsDepositAndWithdrawals}`, `${resource.brands}.${resource.conversionSettingsOthers}`],
      children: false,
      fallback: true,
    }),
  },
  {
    id: 18,
    name: 'legal',
    menuItem: true,
    component: lazyWithRetry(() => import('pages/BrandLegalAgreements')),
    icon: 'LegalIcon',
    exact: true,
    path: 'legalAgreements',
    key: 'legalAgreements',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.legal}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 10,
    menuItem: true,
    name: 'standards',
    component: lazyWithRetry(() => import('pages/BrandStandardSettings')),
    icon: 'StandardIcon',
    exact: true,
    path: 'standards',
    key: 'standards',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.standards}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 11,
    menuParentId: 4,
    component: lazyWithRetry(() => import('features/gameManagement/pages/BrandProviderGames')),
    icon: 'BrandSettingIcon',
    path: 'providerGames',
    key: 'providerGames',
    exact: true,
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
        isActive: false,
      },
      {
        name: 'providersAndGames',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.casinoProduct}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 12,
    menuParentId: 9,
    component: lazyWithRetry(() => import('pages/DepositLogs')),
    icon: 'BrandSettingIcon',
    path: `${conversionRouteKey[title.brandSetting.deposit]}`,
    key: `${conversionRouteKey[title.brandSetting.deposit]}`,
    exact: true,
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.conversionSettingsDepositAndWithdrawals}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 13,
    menuParentId: 9,
    component: lazyWithRetry(() => import('pages/WithdrawalLogs')),
    icon: 'BrandSettingIcon',
    path: `${conversionRouteKey[title.brandSetting.withdrawal]}`,
    key: `${conversionRouteKey[title.brandSetting.withdrawal]}`,
    exact: true,
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
  },
  {
    id: 14,
    menuParentId: 9,
    component: lazyWithRetry(() => import('pages/OtherLogs')),
    icon: 'BrandSettingIcon',
    path: `${conversionRouteKey[title.brandSetting.other]}`,
    key: `${conversionRouteKey[title.brandSetting.other]}`,
    exact: true,
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.conversionSettingsOthers}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 17,
    name: 'operatorLimits',
    menuParentId: 16,
    component: lazyWithRetry(() => import('pages/BrandLargeTransactionLogs')),
    icon: 'ProductIcon',
    exact: true,
    path: 'largeTransactionLogs',
    key: 'largeTransactionLogs',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.largeTransactions}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 19,
    menuParentId: 6,
    component: lazyWithRetry(() => import('pages/BrandPaymentMethodLogs')),
    icon: 'BrandPaymentIcon',
    exact: true,
    path: 'paymentMethodLogs',
    key: 'paymentMethodLogs',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.payments}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 20,
    menuParentId: 6,
    component: lazyWithRetry(() => import('pages/ConfigureBrandPaymentMethod')),
    icon: 'BrandPaymentIcon',
    exact: true,
    path: 'configurePayment',
    key: 'configurePayment',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'Home',
        path: '/',
      },
      {
        name: 'Brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.edit,
      rule: `${resource.brands}.${resource.payments}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 21,
    menuParentId: 6,
    component: lazyWithRetry(() => import('pages/ViewBrandPaymentMethod')),
    icon: 'BrandPaymentIcon',
    exact: true,
    path: 'paymentMethod',
    key: 'paymentMethod',
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.payments}`,
      children: false,
      fallback: true,
    }),
  },
  {
    id: 22,
    menuParentId: 4,
    component: lazyWithRetry(() => import('features/gameManagement/pages/JackpotFeedGames')),
    icon: 'BrandSettingIcon',
    path: 'jackpotFeedGames/:jackpotFeedId',
    key: 'jackpotFeedGames/:jackpotFeedId',
    exact: true,
    timeZoneSettings: { editMode: true },
    breadcrumb: [
      {
        name: 'home',
        path: '/',
      },
      {
        name: 'brands',
        path: '/brands',
      },
      {
        key: 'name',
        isActive: false,
      },
      {
        name: 'providersAndGames',
      },
    ],
    hide: () => !!Can({
      type: types.view,
      rule: `${resource.brands}.${resource.brandJackpots}`,
      children: false,
      fallback: true,
    }),
  },
] satisfies RouteConfig[];
